import React from 'react';
import MarkdownContent from '../MarkdownContent';

import Button from '../Button/Button';

export default function SurMesure(props) {
	const { blocks } = props;

	return (
		<section className="section-block solutions">
			<div className="container">
				<header>
					<MarkdownContent>
						{blocks.solutions_title.body}
					</MarkdownContent>
				</header>

				<div className="row">
					<div className="col-xs-12 col-sm-6 column1">
						<div>
							<MarkdownContent>
								{blocks.solutions_column1.body}
							</MarkdownContent>
						</div>
					</div>
					<div className="col-xs-12 col-sm-6 column2">
						<div>
							<MarkdownContent>
								{blocks.solutions_column2.body}
							</MarkdownContent>
						</div>
					</div>
					<div className="clearfix"></div>
					<div className="col-xs-12 outro">
						<p>
							<Button
								href={
									blocks.solutions_outro.frontmatter.linkURL
								}
								className="btn-primary btn-lg"
								sfx="rising-pops"
							>
								{blocks.solutions_outro.frontmatter.linkTitle}
							</Button>
						</p>
					</div>
				</div>
			</div>
		</section>
	);
}
